export namespace ReportsConstants {
  export const Table = 'Table';
  export const ReportsForm = 'ReportForm';
  export const ReportsFormFirstTime = 'ReportFormFirstTime';
}
